import { render } from "./stampConfig.vue?vue&type=template&id=56d6014f&scoped=true"
import script from "./stampConfig.vue?vue&type=script&lang=js"
export * from "./stampConfig.vue?vue&type=script&lang=js"

import "./stampConfig.vue?vue&type=style&index=0&id=56d6014f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d6014f"]])

export default __exports__